import { IInterventionRepository, GeoJsonValueObject } from '@gishub/domain';
import { axiosClient } from '../http/axios-client';

export class InterventionRepository implements IInterventionRepository {
  async getByAmbit(filters: any): Promise<GeoJsonValueObject> {
    const response = await axiosClient.post<GeoJsonValueObject>('/interventions/ambit', filters);
    return response.data;
  }
}
